import { useTranslation } from 'react-i18next';
import type { TaskCardType } from '@econtractor/types';
import { getTaskCardFileBuckets } from '../helpers/splitTaskFiles';
import TaskCardFiles from './TaskCardFiles';
import SolarIcon from 'components/icons/SolarIcon';

interface TaskCardFilesTabProps {
    task: TaskCardType;
}

const TaskCardFilesTab = ({ task }: TaskCardFilesTabProps) => {
    const { t } = useTranslation(['Tasks']);
    const { files } = getTaskCardFileBuckets(task);

    return (
        <section className="task-card-section">
            <div className="task-card-section__label">
                {t('labelFiles')}
                {files.length > 0 ? ` (${files.length})` : ''}
            </div>
            {files.length > 0 ? (
                <div className="task-card-panel">
                    <TaskCardFiles taskId={task.ID} files={files} />
                </div>
            ) : (
                <div className="task-card-empty">
                    <SolarIcon name="paperclip" className="me-2" />
                    {t('emptyFiles')}
                </div>
            )}
        </section>
    );
};

export default TaskCardFilesTab;
